export default __webpack_public_path__ + "static/media/img-6.386f4399.jpg";